/**
 * 认证授权模块路由配置
 */
import type { RouteRecordRaw } from 'vue-router'
import { LoginView, RegisterView } from '@/modules/auth/views'

const authRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: {
      title: '登录',
      requiresAuth: false,
      hidden: true
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterView,
    meta: {
      title: '用户注册',
      requiresAuth: false,
      hidden: true
    }
  }
]

export default authRoutes

